class Forms {
	constructor(elem) {
		var self = this;

		this.elem = elem;
		this.fields = {};

		var fields = elem.find('input, textarea, select');

		fields.each(function (key, item) {
			var field = $(item);
			if (field.data('validators')) {
				console.log('validator found: ', field);
				var id = field.attr('name');
				var validators = field.data('validators').replace(/ /g, '').split(',');
				var prompt = field.data('prompt');
				var regexPrompt = field.data('regex-prompt');
				var regex = field.data('regex');

				var validator = {
					identifier: id,
					rules: []
				};

				if (validators.length) {
					for (var i in validators) {
						var val = {
							type: self.convertValidator(validators[i])
						}

						if (prompt && prompt.length > i) {
							val.prompt = prompt;
						}

						validator.rules.push(val);
					}

					if (regex && regex.length) {
						var val = {
							type: 'regExp[' + regex + ']'
						}

						if (prompt && prompt.length > i) {
							val.prompt = regexPrompt;
						}

						validator.rules.push(val);
					}
				}

				self.fields[id] = validator;

				//Validate on input change
				field.on('change keyup paste focus', () => {
					var inputValue = field.val();

					// Check if input type is radio
					if (field.attr('type') === 'radio') {
						return;
					}

					if (self.onChange(validators, regex, inputValue)) {
						field.closest('.field').addClass('valid');
						field.closest('.field').removeClass('invalid');
					} else {
						field.closest('.field').addClass('invalid');
						field.closest('.field').removeClass('valid');
					}
				});
			}
		});
	}


	// On input change
	onChange(validators, regex, value) {
		var self = this;
		let results = []
		validators.forEach((item) => {
			switch (item) {
				case 'RequiredValidator':
					results.push(self.validateEmpty(value))
					break;
				case 'EmailValidator':
					results.push(self.validateEmail(value))
					break;
				default:
					results.push(self.validateDate(value, item))
			}
		})
		if (regex) {
			results.push(self.validateRegex(value, regex))
		}

		if (results.indexOf(false) >= 0) {
			return false;
		} else {
			return true;
		}
	}

	validateEmpty(value) {
		return value.length >= 1
	}

	validateEmail(value) {
		let emailRegex = /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;

		return emailRegex.test(value);
	}

	validateDate(value, type) {
		let regex = null;
		if (type === "DateDDMMYYYYValidator" || type === "DateMMDDYYYYValidator") {
			regex = /([0-9]{2})([\/]{1})([0-9]{2})([\/]{1})([0-9]{4})$/
		} else if (type === "DateYYYYMMDDValidator") {
			regex = /([0-9]{4})([-]{1})([0-9]{2})([-]{1})([0-9]{2})$/
		}

		return regex.test(value);
	}

	validateRegex(value, regex) {
		let str = regex.replace(/^\/(.*)\/[g|i|m|u|y]*/, "$1");
		let reg = new RegExp(str);

		return reg.test(value);
	}

	convertValidator(validator) {
		// This will map EpiServer validation identifiers to Semantic UI validation methods
		var validators = {
			'RequiredValidator': 'empty',
			'EmailValidator': 'email',
			'DateDDMMYYYYValidator': 'regExp[/([0-9]{2})([\/]{1})([0-9]{2})([\/]{1})([0-9]{4})$/]',	// 12/17/1988
			'DateMMDDYYYYValidator': 'regExp[/([0-9]{2})([\/]{1})([0-9]{2})([\/]{1})([0-9]{4})$/]', // 17/12/1988
			'DateYYYYMMDDValidator': 'regExp[/([0-9]{4})([-]{1})([0-9]{2})([-]{1})([0-9]{2})$/]'  // 1988-12-17
		};

		if (validators[validator]) {
			return validators[validator];
		}

		return validator;
	}
}

export default Forms;